module.exports = __webpack_public_path__ + "static/media/gd.0e3d254c.svg";